var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('nobr',[_c('i',{staticClass:"fas fa-coins pr-1 fa-pull-left"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }